import React from "react";

import { percentCompactFormatter } from "../utils";

interface GaugeValueProps {
    value: number;
}

export const GaugeValue = (props: GaugeValueProps) => {
    const { value } = props;

    const formattedValue = percentCompactFormatter.format(value);

    //check to see if the value is a decimal or whole number
    //adjust the x coordinate by the length of the number
    //(need to check for decimal because the size of the decimal throws the centering off)
    const getValueXCoordinate = () =>
        ((formattedValue.toString().length - 1.5) / 10) * -1;

    return (
        <text
            fontFamily="'hkgrotesk_bold'"
            fontWeight="bold"
            fontStyle="italic"
            fontSize=".2"
            fill="#21006E"
            x={`${getValueXCoordinate()}`}
            y="-.4"
        >
            {formattedValue}
        </text>
    );
};
